import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useUserIdentityState } from '@provider/user-identity';
import { ErrorMessage } from '../../../atoms/Error/Error.js';
import { getPortalsForUserQuery } from '../api.get-for-user.js';
import { jsx } from 'react/jsx-runtime';

function PortalErrorMessage(props) {
  const queryClient = useQueryClient();
  const user = useUserIdentityState(state => state.user);
  const [isLoading, setLoading] = useState(false);
  const retry = () => {
    const query = getPortalsForUserQuery(user);
    const isFetching = queryClient.isFetching(query);

    // If our status isn't an array or undefined, that means it is a promise
    // and hence we're already attempting to refetch our status. Bail out!
    if (isFetching) {
      return;
    }
    setLoading(true);
    queryClient.fetchQuery(query).catch(() => {
      setLoading(false);
    });
  };
  return /*#__PURE__*/jsx(ErrorMessage, {
    ref: props.ref,
    isLoading: isLoading,
    onRetry: retry
  });
}

export { PortalErrorMessage };
//# sourceMappingURL=message.error.js.map
